import jsPDF from "jspdf";
import "./Css/InsuranceForm.css";
import html2canvas from "html2canvas";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import "./Css/PrintEqunry.css";
import { APL_LINK } from "../ServiceConnection/serviceconnection";
import Loader from "./Loader";
// ForwardRef to pass the ref from parent to child
const InsuranceForm = forwardRef((props, ref) => {
  const [loading, setLoading] = useState(false);
  const handlePrint = () => {
    window.print();
  };
  console.log("InsuranceForm props", props);
  const data = props.downloadForm;
  console.log("InsuranceForm data", data);
  const SignImg = props.SignImg;
  const DringImg = props.DringImg;
  console.log("InsuranceForm SignImg", SignImg);

  // useEffect(() => {
  //     if (data && Object.keys(data).length > 0) {
  //         handleDownloadPDF();
  //     }
  // }, [data]);

  const handleDownloadPDF = () => {
    if (!data || Object.keys(data).length === 0) {
      return;
    }
    setLoading(true);

    // Get all the part elements
    const AgreePart1 = document.getElementById("part1");

    // Create PDF with compression options
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
      compress: true,
    });

    const renderPart = (element, isFirstPart) => {
      return html2canvas(element, {
        scale: 2, // Increase scale for higher resolution (this will result in larger file size)
        useCORS: true,
        logging: false,
        allowTaint: true,
        letterRendering: true,
        imageTimeout: 0,
        backgroundColor: "#FFFFFF", // Set explicit white background instead of null
      }).then((canvas) => {
        // Use PNG for higher quality
        const imgData = canvas.toDataURL("image/png", 1); // Set quality to 1 for full resolution
        const imgWidth = 210;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        if (!isFirstPart) {
          pdf.addPage();
        }

        pdf.addImage(imgData, "PNG", 10, 10, imgWidth - 20, imgHeight - 20);
      });
    };
    renderPart(AgreePart1, true)
      .then(() => {
        pdf.setProperties({
          title: "Agreement",
          subject: "Car Rental Agreement",
          creator: "Rapid Car Leasing",
          author: "System",
        });

        pdf.save(
          `${
            data?.first_name +
              " " +
              data?.last_name +
              "/" +
              data?.car_data[0]?.car_tagline +
              "/" +
              data?.car_data[0]?.registration_company || " "
          }.pdf`
        );
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
        setLoading(false);
      });
  };

  useImperativeHandle(ref, () => ({
    handleDownloadPDF: () => {
      if (!data || Object.keys(data).length === 0) {
        console.warn("Data not ready yet.");
        return;
      }
      handleDownloadPDF();
    },
    handlePrint,
  }));

  return (
    <div>
      {loading && <Loader />}

      <div id="pdf-content" className="insurance_contr">
        {/**-------------------------PDF SLIDE 1--------------------------- */}
        <div className="part1" id="part1">
          <h1 className="agreement-title">
            Agreement of Terms and Condition for Car Insurance
          </h1>
          <div className="agreement-section">
            <p>
              <span className="bold-text">Company / Car Owner:</span>{" "}
              {data?.car_data[0].registration_company || "NA "}
            </p>
            <p>
              <span className="bold-text">Company / Owner Address:</span>{" "}
              {data?.car_data[0].registration_company_address || "NA "}
            </p>

            <p>
              <span className="bold-text">Driver:</span>{" "}
              {data?.first_name || "NA "} {data?.last_name || "NA "}
            </p>
            <p>
              <span className="bold-text">DL #:</span>
              {data?.driving_licence || "NA"}
            </p>

            <p>
              <span className="bold-text">Insurance Policy#:</span>
              {data?.insurance_policy || "NA"}
            </p>
            <p>
              <span className="bold-text">Car Info:</span> (
              {data?.car_data?.[0]?.car_tagline
                ? data.car_data[0].car_tagline
                : "NA"}{" "}
              / LP#:{" "}
              {data?.car_data?.[0]?.car_no ? data.car_data[0].car_no : "NA"} )
              VIN#: {data?.car_data?.[0]?.vin ? data.car_data[0].vin : "NA"} /
              Make Year:{" "}
              {data?.car_data?.[0]?.make_year
                ? data.car_data[0].make_year
                : "NA"}{" "}
              / Model:{" "}
              {data?.car_data?.[0]?.model_name
                ? data.car_data[0].model_name
                : "NA"}
            </p>

            {/* <p>
                        <span className="bold-text">Start date</span> Monday, December 23, 2024
                    </p>
                    <p>
                        <span className="bold-text">End date</span>{" "}
                    </p> */}
          </div>

          <div className="agreement-text">
            <p>
              The above company/owner will be lien Holder / Lessor/ additional
              interest and loss payee for the above policy. Any Refund at the
              time of cancellation or payments will be directly sent to the
              company / Owner.
            </p>
            <p>
              I the Renter will be using the car for Rideshare and personal use
              only. I am personally liable for any damage / deductible and any
              other fees or charges.
            </p>
          </div>

          <div className="signature-section">
            <p className="bold-text">Signature</p>

            <img
              className="SignImg_inssurnce"
              src={SignImg + data?.signature_image || ""}
            />

            <p className="bold-text">Name</p>
            <p>
              {data?.first_name || "NA "} {data?.last_name || "NA "}
            </p>

            <p className="bold-text">Picture of DL</p>

            <img
              className="DriingLImg dl_picture_inssurence_form"
              src={APL_LINK + (data?.driving_licence_image_full || "")}
            />
          </div>

          <div className="agreement-footer">
            <p>
              (
              {data?.car_data?.[0]?.car_tagline
                ? data.car_data[0].car_tagline
                : "NA"}{" "}
              / LP#:{" "}
              {data?.car_data?.[0]?.car_no ? data.car_data[0].car_no : "NA"} )
              VIN#: {data?.car_data?.[0]?.vin ? data.car_data[0].vin : "NA"} /
              Make Year: {data?.car_data[0].make_year || "NA"} / Model:{" "}
              {data?.car_data?.[0]?.model_name
                ? data.car_data[0].model_name
                : "NA"}
            </p>

            <p>
              {data?.company_name || "NA "} {data?.company_address || "NA "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
});

export default InsuranceForm;
